import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
var ReportOptionsDialogComponent = /** @class */ (function () {
    function ReportOptionsDialogComponent(dialogRef, data, fb) {
        this.dialogRef = dialogRef;
        this.fb = fb;
        this._subrelease = new Subject();
        this.AvailableColleges = data.AvailableColleges || [];
        this.AvailableSchools = data.AvailableSchools || [];
        this.canceltext = data.CancelText || 'Cancel';
        this.defaultoptions = data.DefaultOptions;
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'Run Report';
        this.ReportInfo = data.ReportInfo;
        this.title = data.TitleText || 'Choose Report Options';
    }
    Object.defineProperty(ReportOptionsDialogComponent.prototype, "ReportCollege", {
        get: function () {
            return this.ReportOptionsForm && this.ReportOptionsForm.get('ReportCollege');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportOptionsDialogComponent.prototype, "ReportTerm", {
        get: function () {
            return this.ReportOptionsForm && this.ReportOptionsForm.get('ReportTerm');
        },
        enumerable: true,
        configurable: true
    });
    ReportOptionsDialogComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    ReportOptionsDialogComponent.prototype.ngOnInit = function () {
        var self = this;
        // Create report form. If we were provided default options, we can use those to preselect things.
        self.ReportOptionsForm = this.fb.group({
            ReportCollege: [null, Validators.required],
            ReportSchool: [null],
            ReportTerm: [null, Validators.required],
        });
        var patchVals = {
            ReportSchool: null,
            ReportCollege: null,
            ReportTerm: null,
        };
        if (self.defaultoptions) {
            // Have a school?
            if (self.defaultoptions && self.defaultoptions.ReportSchool) {
                // Get the school entry and patch it in.
                var chosenSchool = self.AvailableSchools.find(function (item) {
                    return item.SchoolNumber === self.defaultoptions.ReportSchool.SchoolNumber;
                });
                if (chosenSchool) {
                    patchVals.ReportSchool = chosenSchool;
                }
            }
            // Have a college?
            if (self.defaultoptions && self.defaultoptions.ReportCollege) {
                // Get the college entry and patch it.
                var chosenCollege = self.AvailableColleges.find(function (item) {
                    return item.CollegeID === self.defaultoptions.ReportCollege.CollegeID;
                });
                if (chosenCollege) {
                    patchVals.ReportCollege = chosenCollege;
                }
            }
            // Have a term?
            if (self.defaultoptions && self.defaultoptions.ReportTerm && patchVals.ReportCollege) {
                // Get the term entry and patch it.
                var chosenTerm = patchVals.ReportCollege.Terms.find(function (item) {
                    return item.TermWindowID === self.defaultoptions.ReportTerm.TermWindowID;
                });
                if (chosenTerm) {
                    patchVals.ReportTerm = chosenTerm;
                }
            }
        }
        // Be kind: If the user can set schools, but there's only one available school, pre-select it.
        if (self.ReportInfo.CanSetSchool === true && (self.AvailableSchools && self.AvailableSchools.length === 1)) {
            patchVals.ReportSchool = self.AvailableSchools[0];
        }
        // Patch in default values
        self.ReportOptionsForm.patchValue(patchVals, { emitEvent: false });
        self.ReportOptionsForm.updateValueAndValidity({ emitEvent: false });
        // If we didn't patch in a college, disable the term by default.
        if (!patchVals.ReportCollege) {
            self.ReportOptionsForm.get('ReportTerm').disable();
        }
        // Listen for form changes, so we can enable the term option upon a college selection
        self.ReportOptionsForm.valueChanges.pipe(takeUntil(self._subrelease)).subscribe(function (value) {
            if (value && value.ReportCollege) {
                self.ReportTerm.enable({ onlySelf: true, emitEvent: false });
            }
            else {
                self.ReportTerm.disable({ onlySelf: true, emitEvent: false });
            }
        });
    };
    // #region Cancel Handler Method
    ReportOptionsDialogComponent.prototype.CancelHandler = function () {
        // User cancelled.
        this.dialogRef.close(null);
    };
    // #endregion
    // #region OK Handler Method
    ReportOptionsDialogComponent.prototype.OkHandler = function () {
        // User chose the run the report. Return back the selected options
        var form = this.ReportOptionsForm.getRawValue();
        this.dialogRef.close({
            ReportCollege: form.ReportCollege,
            ReportInfo: this.ReportInfo,
            ReportSchool: form.ReportSchool,
            ReportTerm: form.ReportTerm,
        });
    };
    return ReportOptionsDialogComponent;
}());
export { ReportOptionsDialogComponent };
// #region Custom Classes
// #region Report Options Dialog Options Class
var BaseReportOptionsDialogOptions = /** @class */ (function () {
    function BaseReportOptionsDialogOptions() {
    }
    return BaseReportOptionsDialogOptions;
}());
export { BaseReportOptionsDialogOptions };
// #endregion
// #region Report Run Options Class
var BaseReportRunOptions = /** @class */ (function () {
    function BaseReportRunOptions() {
    }
    return BaseReportRunOptions;
}());
export { BaseReportRunOptions };
// #endregion
// #endregion



// WEBPACK FOOTER //
// ./src/services/dialogs/reportoptions/reportoptions.dialogcomponent.ts.pre-build-optimizer.js